module.exports = __webpack_public_path__ + "img/OA-title.66ad1aba.png";